'use client';

import { useEffect } from 'react';

export function ServiceWorkerRegistrar() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    // SW install parses sw.js and primes caches — real main-thread and
    // network work that shouldn't compete with hydration. Defer to idle.
    const register = () => {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.error('SW registration failed:', err);
      });
    };

    if ('requestIdleCallback' in window) {
      const id = window.requestIdleCallback(register, { timeout: 5000 });
      return () => window.cancelIdleCallback(id);
    }

    const t = setTimeout(register, 3000);
    return () => clearTimeout(t);
  }, []);

  return null;
}
